<template>
  <!-- @search="onSearchSelect" -->
  <a-select
    :loading="loadingList"
    allowClear
    show-search
    :filter-option="false"
    @change="handleInput"
    v-bind="{ ...selectProps }"
  >
    <a-spin v-if="loadingList" slot="notFoundContent" size="small" />
    <a-select-option
      v-if="!loadingList && datas.length > 0"
      disabled
      key="disabled"
    >
      Nhập để tìm kiếm
    </a-select-option>
    <a-select-option v-for="item in datas" :key="item.id">
      {{ item.name }}
    </a-select-option>
  </a-select>
</template>
<script>
import query from "./constant/query";
import debounce from "lodash/debounce";
export default {
  props: {
    selectProps: {
      type: Object,
      default() {
        return {};
      },
    },
    initialDatas: {
      type: Array,
      default() {
        return [];
      },
    },
    variablesQuery: {
      type: Object,
      default() {
        return {};
      },
    },
    // nếu true chọn cái đầu tiên làm mặc định
    isChooseFirst: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    this.onSearchSelect = debounce(this.onSearchSelect, 500);
    return {
      loadingList: false,
      datas: [],
      filter: {},
    };
  },
  model: {
    event: "change",
  },
  methods: {
    handleInput(value) {
      this.$emit("change", value);
    },
    onSearchSelect(input, option) {
      this.datas = [];
      this.$set(this.filter, "query", input);
      this.onGetAllData();
    },
    onGetAllData() {
      this.loadingList = true;
      this.$apollo
        .query({
          query: query.getAllWorkOvertimeRate,
          fetchPolicy: "no-cache",
          variables: {
            query: this.filter.query,
            limit: 20,
            page: 1,
            ...this.variablesQuery,
          },
        })
        .then(({ data }) => {
          if (data?.getAllWorkOvertimeRate?.length >= 0) {
            if (this.initialDatas?.length > 0) {
              const uniqueInitialDatas = [];
              for (let i in this.initialDatas) {
                const item = this.initialDatas[i];
                const find = data.getAllWorkOvertimeRate.find(
                  (e) => e.id === item.id
                );
                if (!find) {
                  uniqueInitialDatas.push(item);
                }
              }
              this.datas = [
                ...data.getAllWorkOvertimeRate,
                ...uniqueInitialDatas,
              ];
            } else {
              this.datas = [...data.getAllWorkOvertimeRate];
            }

            // chọn cái đầu tiên
            if (this.isChooseFirst && !this.selectProps.value) {
              this.handleInput(this.datas[0].id);
            }
            this.loadingList = false;
          }
        })
        .catch((error) => {
          console.log("Không lấy được danh sách", error);
        });
    },
  },
  created() {
    if (this.initialDatas.length > 0) {
      this.datas = [...this.initialDatas];
    } else {
      this.onGetAllData();
    }
  },
};
</script>
